import '@/app/app.css';
import './returns.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {});
